module.exports = __webpack_public_path__ + "img/troll_trapper_small.90a63455.png";